const initialState = {
  cadastre: []
}

const cadastre = (state = initialState, action) => {
  switch (action.type) {
    case "CADASTRE":
      return { ...state, cadastre: action.val }
    default:
      return state
  }
}
export default cadastre
